export default __webpack_public_path__ + "static/media/systemowe5.ac2f1601.jpg";